var map = {
	"./en/awp.json": 4916,
	"./en/base-image.json": 74449,
	"./en/cis.json": 45485,
	"./en/cluster.json": 49254,
	"./en/common.json": 85453,
	"./en/cve-explorer.json": 54832,
	"./en/events.json": 38805,
	"./en/finding-exclusion.json": 30676,
	"./en/image-overview.json": 48507,
	"./en/policy.json": 76230,
	"./en/protected-asset-details.json": 25548,
	"./en/registry.json": 86543,
	"./en/sbom-explorer.json": 54959,
	"./en/sbom.json": 57385,
	"./en/service-account.json": 75489,
	"./en/shiftleft.json": 77601,
	"./en/vulnerability.json": 670,
	"./en/vulnerabilityExclusion.json": 81598,
	"./en/welcome-page.json": 37584,
	"./fr/common.json": 22000,
	"./fr/registry.json": 3054,
	"./fr/welcome-page.json": 53737,
	"./ja/common.json": 36059,
	"./ja/registry.json": 29693,
	"./ja/welcome-page.json": 3526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91759;